import { Component } from '@angular/core'

import { MDBaseButtonComponent } from './base-button.component'

@Component({
  selector: 'f-btn',
  templateUrl: 'f-btn.component.html',
})
export class MDButtonComponent extends MDBaseButtonComponent {}
